// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trasferTwoCardWrapper{
    display:flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
}

.trasferTwoCardWrapper >div{
   width: 45%;
   max-width: 450px;
   border-radius: 12px;
   border: 1px solid #288F43;
   height: 65vh;
   overflow-y: auto;
}

.trasferTwoCardWrapper >div button{
   border: 1px solid var(--Support_Orange);
   padding: 6px 10px;
   background-color: transparent;
   border-radius: 8px ;
   font-weight: 600;
   pointer-events: none;
}

.trasferTwoCardWrapper >div >:first-child{
    padding: 12px;
    background-color: #D6FFDD;
    border-radius: 12px 12px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    position: sticky;
    left: 0px;
    top: 0px;
}
.trasferTwoCardWrapper p{
   margin: 0px;
}

.trasferTwoCardWrapper >div >:nth-child(2){
    padding: 10px;
}

.trasferDriverProfileWrapper{
    width: 100%;
  display: flex;
  gap: 14px;
  margin-top: 20px;
}

.trasferDriverProfileWrapper >div{
    display: flex;
    gap: 10px;
    width:48% ;
}

.trasferDriverProfileWrapper >div>:nth-child(2) {
    width: 100%;
    overflow: hidden;
    white-space: nowrap; 
    text-overflow: ellipsis; 
}

.trasferDriverProfileWrapper >div>:nth-child(2) p {
   color: #8A92A6;
   overflow: hidden;
    white-space: nowrap; 
    text-overflow: ellipsis;
}
.trasferDriverProfileWrapper >div>:nth-child(2) h6 {
   overflow: hidden;
    white-space: nowrap; 
    text-overflow: ellipsis;
}

.trasferDriverProfileWrapper img{
    width: 64px;
    height: 64px;
    object-fit: contain;
    border-radius: 4px;
    border: 1px solid #c7f4ce;
}

.transferInputWrapper{
    margin-top: 25px;
    color: rgba(71, 75, 79, 1);
}

.transferInputWrapper>:nth-child(1){
   padding: 10px;
   width: 100%;
   height: 50px;
   border: 2px solid rgba(128, 128, 128, 0.55);
   border-radius: 8px;
   margin-bottom: 20px;       
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;           
}

.transferInputWrapper>:nth-child(2){
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap:20px
}

.transferInputWrapper>:nth-child(2) >div{
    display: flex;
   justify-content: space-between;
   padding: 10px;
   width: 100%;
   border: 2px solid rgba(128, 128, 128, 0.55);
   border-radius: 8px;
}
/*------------------------ Media query ----------------------- */
@media (max-width:1000px) {
    .trasferDriverProfileWrapper{
       
      flex-direction: column;
      gap: 14px;
    }

    .trasferDriverProfileWrapper >div{
        width: 100%;
    }

    .transferInputWrapper>:nth-child(2){
        grid-template-columns: repeat(1, 1fr);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/transferRequest/transferReq.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;GACG,UAAU;GACV,gBAAgB;GAChB,mBAAmB;GACnB,yBAAyB;GACzB,YAAY;GACZ,gBAAgB;AACnB;;AAEA;GACG,uCAAuC;GACvC,iBAAiB;GACjB,6BAA6B;GAC7B,mBAAmB;GACnB,gBAAgB;GAChB,oBAAoB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,QAAQ;AACZ;AACA;GACG,WAAW;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;EACb,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;GACG,cAAc;GACd,gBAAgB;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;GACG,gBAAgB;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;GACG,aAAa;GACb,WAAW;GACX,YAAY;GACZ,2CAA2C;GAC3C,kBAAkB;GAClB,mBAAmB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC;AACJ;;AAEA;IACI,aAAa;GACd,8BAA8B;GAC9B,aAAa;GACb,WAAW;GACX,2CAA2C;GAC3C,kBAAkB;AACrB;AACA,gEAAgE;AAChE;IACI;;MAEE,sBAAsB;MACtB,SAAS;IACX;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[".trasferTwoCardWrapper{\n    display:flex;\n    align-items: center;\n    justify-content: center;\n    gap: 20px;\n}\n\n.trasferTwoCardWrapper >div{\n   width: 45%;\n   max-width: 450px;\n   border-radius: 12px;\n   border: 1px solid #288F43;\n   height: 65vh;\n   overflow-y: auto;\n}\n\n.trasferTwoCardWrapper >div button{\n   border: 1px solid var(--Support_Orange);\n   padding: 6px 10px;\n   background-color: transparent;\n   border-radius: 8px ;\n   font-weight: 600;\n   pointer-events: none;\n}\n\n.trasferTwoCardWrapper >div >:first-child{\n    padding: 12px;\n    background-color: #D6FFDD;\n    border-radius: 12px 12px 0px 0px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-weight: 600;\n    position: sticky;\n    left: 0px;\n    top: 0px;\n}\n.trasferTwoCardWrapper p{\n   margin: 0px;\n}\n\n.trasferTwoCardWrapper >div >:nth-child(2){\n    padding: 10px;\n}\n\n.trasferDriverProfileWrapper{\n    width: 100%;\n  display: flex;\n  gap: 14px;\n  margin-top: 20px;\n}\n\n.trasferDriverProfileWrapper >div{\n    display: flex;\n    gap: 10px;\n    width:48% ;\n}\n\n.trasferDriverProfileWrapper >div>:nth-child(2) {\n    width: 100%;\n    overflow: hidden;\n    white-space: nowrap; \n    text-overflow: ellipsis; \n}\n\n.trasferDriverProfileWrapper >div>:nth-child(2) p {\n   color: #8A92A6;\n   overflow: hidden;\n    white-space: nowrap; \n    text-overflow: ellipsis;\n}\n.trasferDriverProfileWrapper >div>:nth-child(2) h6 {\n   overflow: hidden;\n    white-space: nowrap; \n    text-overflow: ellipsis;\n}\n\n.trasferDriverProfileWrapper img{\n    width: 64px;\n    height: 64px;\n    object-fit: contain;\n    border-radius: 4px;\n    border: 1px solid #c7f4ce;\n}\n\n.transferInputWrapper{\n    margin-top: 25px;\n    color: rgba(71, 75, 79, 1);\n}\n\n.transferInputWrapper>:nth-child(1){\n   padding: 10px;\n   width: 100%;\n   height: 50px;\n   border: 2px solid rgba(128, 128, 128, 0.55);\n   border-radius: 8px;\n   margin-bottom: 20px;       \n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;           \n}\n\n.transferInputWrapper>:nth-child(2){\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap:20px\n}\n\n.transferInputWrapper>:nth-child(2) >div{\n    display: flex;\n   justify-content: space-between;\n   padding: 10px;\n   width: 100%;\n   border: 2px solid rgba(128, 128, 128, 0.55);\n   border-radius: 8px;\n}\n/*------------------------ Media query ----------------------- */\n@media (max-width:1000px) {\n    .trasferDriverProfileWrapper{\n       \n      flex-direction: column;\n      gap: 14px;\n    }\n\n    .trasferDriverProfileWrapper >div{\n        width: 100%;\n    }\n\n    .transferInputWrapper>:nth-child(2){\n        grid-template-columns: repeat(1, 1fr);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
